import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      ...theme.typography.regular12,
    },
  }),
  { name: 'ItemPlaceholder' }
);
